import LessonComponent from "./LessonComponent";
export default LessonComponent;
